import ReactGA from "react-ga";
import Cookies from "universal-cookie";
import { v4 as uuidv4 } from "uuid";
const userIdCookie = "userIdSRC";
const CookieMaxAge = 60 * 60 * 24 * 365 * 5;
const AppName = "Pace";

const isProductionEnv = () => process.env.NODE_ENV === "production";
const getGoogleAnalyticsKey = () => process.env.REACT_APP_GOOGLE_ANALYTICS_KEY || "";

const productionMiddleware = (operation: () => void) => {
  isProductionEnv() && operation();
};

export const initialize = () =>
  productionMiddleware(() => {
    const cookies = new Cookies();
    const userCookie = cookies.get(userIdCookie);
    const currentUser = userCookie ? userCookie : uuidv4();
    userCookie === undefined &&
      cookies.set(userIdCookie, currentUser, {
        path: "/",
        sameSite: "strict",
        maxAge: CookieMaxAge,
      });
    if (isProductionEnv()) {
      ReactGA.initialize(getGoogleAnalyticsKey());
      ReactGA.set({ [userIdCookie]: currentUser, app: AppName });
    }
  });

export const logPageView = (url: string) =>
  productionMiddleware(() => {
    ReactGA.pageview(url);
  });

export const logEvent = (featureName: string, action: string, details?: any) =>
  productionMiddleware(() => {
    if (isProductionEnv()) {
      ReactGA.event({
        category: featureName,
        action,
        label: details ? JSON.stringify(details) : undefined,
      });
    }
  });
